import React from "react";
import Skeleton from "@mui/material/Skeleton";

const ProfileCardsSkeleton = ({ card, showHeader = true }) => {
  const skeletons = Array.from({ length: card });
  return (
    <div className="max-w-8xl mx-auto p-4 bg-transparent">
      {/* Header Skeleton */}
      {showHeader && (
        <div className="flex flex-col items-center text-center space-y-4 mb-12 animate-pulse">
          <div className="flex items-center justify-center space-x-3">
            <Skeleton
              variant="circular"
              width={32}
              height={32}
            />
            <Skeleton
              variant="text"
              width={160}
              height={40}
              sx={{
                borderRadius: "10px",
              }}
            />
          </div>

          <Skeleton
            variant="text"
            width="70%"
            height={50}
            sx={{
              borderRadius: "12px",
            }}
          />
          <Skeleton
            variant="text"
            width="85%"
            height={30}
            sx={{
              borderRadius: "10px",
            }}
          />
        </div>
      )}

      {/* Profile Cards Grid Skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {skeletons.map((_, i) => (
          <div
            key={i}
            className="flex flex-col p-4 rounded-2xl bg-transparent transition-all duration-300"
          >
            {/* Image Skeleton */}
            <div className="relative">
              <Skeleton
                variant="rounded"
                width="100%"
                height={256}
                sx={{
                  borderRadius: "16px",
                }}
              />
              <div className="absolute top-3 right-3">
                <Skeleton
                  variant="circular"
                  width={30}
                  height={30}
                />
              </div>
              <div className="absolute top-3 left-3">
                <Skeleton
                  variant="rounded"
                  width={70}
                  height={25}
                  sx={{
                    borderRadius: "20px",
                  }}
                />
              </div>
            </div>

            {/* Content Skeleton */}
            <div className="mt-5 space-y-3">
              <Skeleton
                variant="text"
                width="80%"
                height={30}
              />
              <Skeleton
                variant="text"
                width="60%"
                height={25}
              />

              {/* Tags */}
              <div className="flex space-x-3 mt-3">
                <Skeleton
                  variant="rounded"
                  width={90}
                  height={35}
                  sx={{
                    borderRadius: "20px",
                  }}
                />
                <Skeleton
                  variant="rounded"
                  width={90}
                  height={35}
                  sx={{
                    borderRadius: "20px",
                  }}
                />
              </div>

              {/* Button Skeleton */}
              <div className="mt-6">
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={45}
                  sx={{
                    borderRadius: "12px",
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileCardsSkeleton;
